import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestServiceService } from '../ticketing-request/helper/request-service.service';
import { CdkCustomMdlModule } from '@core/customCDK/cdkCustomMdl/cdk-custom-mdl.module';
import { TicketingService } from '../helper/ticketing.service';

@Component({
  selector: 'app-ticketing',
  standalone: true,
  imports: [
    CommonModule,
    CdkCustomMdlModule
  ],
  templateUrl: './ticketing.component.html',
  styleUrl: './ticketing.component.scss'
})
export class TicketingComponent {

  _TicketingService: TicketingService = inject(TicketingService);
  _ticketRequest: RequestServiceService = inject(RequestServiceService);


  createRequest() {
    this._ticketRequest.getSupportType().subscribe((res: any) => {
      this._TicketingService.openSupportTypes();
    })

  }
}
